<div class="insurance-icon">
    <i
        [ctrlIcon]="icon()"
        [size]="iconSize()"
        class="c:blue-700"
    ></i>
</div>
<div class="insurance-details">
    <div
        class="insurance-name"
        [innerHTML]="contract()?.insuranceType | insuranceType: 'collabsible' | insertHyphens"
    ></div>
    <div class="insurance-number">Versicherungsnr.: {{ contract()?.insuranceNumber }}</div>
    @if (contract().hasOpenDamages) {
        <div class="pill">{{ openDamage() }}</div>
    }
</div>
<i
    ctrlIcon="chevron_right"
    class="chevron-icon c:blue-700"
></i>
